import { Router } from '@angular/router';
import { Token } from './../../../models/token.model';
import { LoginModalService } from 'src/app/services/auth/login-modal.service';
import { AuthBaseService } from 'src/app/services/auth/auth-base.service';
import { YourHistoricTest } from 'src/app/models/your-historic-test.model';
import { Paginate } from './../../../models/paginate.model';
import { Response } from './../../../models/response.model';
import { forkJoin, Subscription } from 'rxjs';
import { YourHistoricTestService } from 'src/app/services/your-historic-test.service';
import { TipoLiderService } from 'src/app/services/tipo-lider.service';
import { environment } from './../../../../environments/environment';
import { TipoLider } from 'src/app/models/tipo-lider.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-test-list',
  templateUrl: './test-list.component.html',
  styleUrls: ['./test-list.component.scss']
})
export class TestListComponent implements OnInit {
  storageUrl = environment.BASE_STORAGE_URL;

  currentLoggedUserSubscription: Subscription;
  dataSubscription: Subscription;
  openedModalSubscription: Subscription;
  modalResultSubscription: Subscription;

  @Input() tipoLiders: TipoLider[] = [];

  @Input() currentTipoId: number;
  @Output() tipoLiderEmitter: EventEmitter<TipoLider> = new EventEmitter(null);

  currentLoggedUser: Token = new Token();

  constructor(
    private router: Router,
    private tipoLiderService: TipoLiderService,
    public yourHistoricTestService: YourHistoricTestService,
    private authBaseService: AuthBaseService,
    private loginModalService: LoginModalService,
  ) { }

  ngOnInit(): void {
    this.getLoggedUser();
  }

  getLoggedUser(): void {
    this.currentLoggedUserSubscription = this.authBaseService.watchUsuarioLogado().subscribe((res: Token) => {
      this.currentLoggedUser = res;
      this.getData();
    })
  }

  getData(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }

    const tipo = this.tipoLiderService.getTipoLider();
    const historic = this.yourHistoricTestService.getHistoricByUserPaged({ _sortDirections: 'DESC', _sortFields: 'dtInclusao' });

    if (this.currentLoggedUser) {

      this.dataSubscription = forkJoin([tipo, historic]).subscribe((res: [Response<TipoLider[]>, Response<Paginate<YourHistoricTest>>]) => {
        let historic = res[1].data.list;
        this.tipoLiders = res[0].data;

        for (let i = 0; i < this.tipoLiders.length; i++) {
          for (let j = 0; j < historic.length; j++) {
            if (typeof this.tipoLiders[i].respondidoEm === 'undefined' && historic[j].idTipoAvaliacao === this.tipoLiders[i].id) {
              this.tipoLiders[i].respondidoEm = historic[j].dataAvaliacao;

              if (this.currentTipoId && this.currentTipoId === this.tipoLiders[i].id) {
                this.tipoLiderEmitter.emit(this.tipoLiders[i]);
              }

              break;
            }
          }
        }

      })

    } else {
      this.dataSubscription = tipo.subscribe((res: Response<TipoLider[]>) => {
        this.tipoLiders = res.data;
      })
    }

  }

  iChoseThisTest(id: number) {
    if (this.currentLoggedUser === null) {
      this.loginModalService.openModalLogin();

      this.openedModalSubscription = this.loginModalService.openedModalSubject.subscribe((res) => {
        res.afterClosed().subscribe((res: { isLoggedIn: boolean }) => {
          if (res.isLoggedIn) {
            this.router.navigate(['/do-the-test', id]);
          }

          this.unsubscribeModal();
        })
      })

    } else {
      this.router.navigate(['/do-the-test', id]);
    }
  }

  unsubscribeModal(): void {
    if (this.openedModalSubscription) {
      this.openedModalSubscription.unsubscribe();
    }

    if (this.modalResultSubscription) {
      this.modalResultSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }
}
